var swiper = new Swiper(".mobile-swiper", {
  spaceBetween: 12,
  slidesPerView: 1.24,

  breakpoints: {
    420: {
      slidesPerView: 1.44,
    },
    480: {
      slidesPerView: 1.65,
    },
    550: {
      slidesPerView: 1.91,
    },
    600: {
      slidesPerView: 2.09,
    },
    650: {
      slidesPerView: 2.27,
    },
    700: {
      slidesPerView: 2.49,
    },
    750: {
      slidesPerView: 2.68,
    },
    768: {
      slidesPerView: 2,
    },
    820: {
      slidesPerView: 2.5,
    },
    880: {
      slidesPerView: 3,
    },
    950: {
      slidesPerView: 3.5,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
